import { useMutation, useQuery, useQueryClient } from "react-query";
import { authHeaders } from "./auth-header";
import { getApiErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { AxiosError } from "axios";
import { useSessionContext } from "./session.context";
import {
  CreateDeviceAuthorizationModel,
  MutateResponseDeviceAuthorizationModel,
  QueryKeyDeviceAuthorization,
  createDeviceAuthorizationController,
} from "@core/model/query-model-device-authorization";

export function useQyCreateDeviceAuthorization(
  onSuccess?:
    | ((
        data: MutateResponseDeviceAuthorizationModel
      ) => void | Promise<unknown>)
    | undefined,
  onError?: ((error: unknown) => void | Promise<unknown>) | undefined
) {
  const { checkSession } = useSessionContext();
  const queryClient = useQueryClient();
  const { showProgress, hideProgress, showError } = useNotificationContext();

  const apiFn = async (payload: CreateDeviceAuthorizationModel) => {
    await checkSession();

    showProgress();
    const operation = await createDeviceAuthorizationController(
      payload,
      authHeaders()
    );
    const response = (await operation()).data;
    return response as MutateResponseDeviceAuthorizationModel;
  };

  return useMutation({
    mutationFn: apiFn,
    onSuccess: (response) => {
      hideProgress();
      queryClient.invalidateQueries(QueryKeyDeviceAuthorization);
      if (onSuccess) {
        onSuccess(response);
      }
    },
    onError: (err: AxiosError) => {
      hideProgress();
      const message = getApiErrorMessage(err);
      showError(message);

      if (onError) {
        onError(err);
      }
    },
    onSettled() {
      hideProgress();
    },
  });
}
